import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from '@amzn/atoz-web/Link';
import { Col } from '@amzn/atoz-web/Col';
import { Text } from '@amzn/atoz-web/Text';
export var EmptyShiftsMessaging = function (_a) {
    var resetFilters = _a.resetFilters, viewUnavailable = _a.viewUnavailable, numberOfIneligibleShiftsPerSelectedDay = _a.numberOfIneligibleShiftsPerSelectedDay, numberOfAvailableShiftsPerSelectedDay = _a.numberOfAvailableShiftsPerSelectedDay;
    var t = useTranslation().t;
    return (React.createElement(Col, { display: "flex", padding: ['S700', 'S200'], role: "listitem" }, numberOfAvailableShiftsPerSelectedDay ? (React.createElement(React.Fragment, null,
        React.createElement(Text, { textAlign: "center" },
            t('ess_findshifts_reset_filters_text_number_available', { number: numberOfAvailableShiftsPerSelectedDay }),
            numberOfIneligibleShiftsPerSelectedDay > 0 ? (React.createElement(React.Fragment, null, "\u00A0")) : ('.'),
            numberOfIneligibleShiftsPerSelectedDay > 0 &&
                t('ess_findshifts_reset_filters_text_number_unavailable', {
                    number: numberOfIneligibleShiftsPerSelectedDay
                })),
        React.createElement(Text, { textAlign: "center" },
            React.createElement(Link, { onClick: resetFilters }, t('ess_findshifts_reset_filters_text_link')),
            t('ess_findshifts_reset_filters_text')))) : numberOfIneligibleShiftsPerSelectedDay ? (React.createElement(React.Fragment, null,
        React.createElement(Text, { textAlign: "center" },
            t('ess_findshifts_reset_filters_text_unavailable'),
            "(",
            t('ess_findshifts_reset_filters_text_unavailable_parenthesis'),
            React.createElement(Link, { onClick: function () {
                    resetFilters();
                    viewUnavailable();
                } }, t('ess_findshifts_reset_filters_text_unavailable_parenthesis_link', {
                number: numberOfIneligibleShiftsPerSelectedDay
            })),
            ")."),
        React.createElement(Text, { textAlign: "center", color: "neutral70" }, t('ess_findshifts_reset_filters_text_unavailable_check_back_later')))) : (React.createElement(React.Fragment, null,
        React.createElement(Text, { textAlign: "center" }, t('ess_findshifts_reset_filters_text_no_available')),
        React.createElement(Text, { textAlign: "center", color: "neutral70" }, t('ess_findshifts_reset_filters_text_unavailable_check_back_later'))))));
};
